import 'vuetify/styles';
import { createVuetify } from 'vuetify';

export const vuetify = createVuetify({});
